import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';


const HeroSection = ({ data }) => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="banner.jpeg" 
          alt="Dr. Subhashini G"
          className="hero-image"
        />
        {/* <div className="hero-overlay"></div> */}
      </div>

      {/* <div className="hero-content-wrapper">
        <div className="hero-content">
          <div className="hero-badge">
            Telangana Bar Council Elections 2026
          </div>
          
          <h1 className="hero-title">
            {data.mainHeadline}
            <br />
            {data.subHeadline}
          </h1>

          <p className="hero-tagline">
            {data.tagline}
          </p>

          <div className="hero-cta-group">
            <Button 
              className="btn-primary btn-large"
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {data.ctaText}
            </Button>
            <Button 
              className="btn-secondary btn-large"
              onClick={scrollToAbout}
            >
              Learn More
            </Button>
          </div>
        </div>

        <button 
          className="hero-scroll-indicator"
          onClick={scrollToAbout}
          aria-label="Scroll to content"
        >
          <ChevronDown size={32} />
        </button>
      </div> */}
    </section>
  );
};

export default HeroSection;
